export default {
	// 获取足球赛事状态
	MatchState: [
		{ value: 0, label: '未开始' },
		{ value: 1, label: '上半场' },
		{ value: 2, label: '中场' },
		{ value: 3, label: '下半场' },
		{ value: 4, label: '完场' },
		{ value: 5, label: '中断' },
		{ value: 6, label: '取消' },
		{ value: 7, label: '加时' },
		{ value: 8, label: '加时赛上半场' },
		{ value: 9, label: '加时赛下半场' },
		{ value: 10, label: '完场' },
		{ value: 11, label: '点球大战' },
		{ value: 13, label: '延期' },
		{ value: 14, label: '腰斩' },
		{ value: 15, label: '待定' },
		{ value: 16, label: '金球' },
		{ value: 17, label: '未开始' },
		{ value: 18, label: '比赛异常' },
		{ value: 19, label: '弃权' },
	],

	favoriteType: Object.freeze({
		"player": 0,//: '球员',
		"team": 1,//: '球队',
		"anchor": 2,//: '主播',
		// "match": 3,//: '足球赛事',
		"comp": 4,//: '赛事',
		"match": 5,//: '比赛',
		"circle": 6,//: '圈子',
		"topic": 7,//: '话题',
		"user": 9,//: '用户',
	}),


	// 获取篮球赛事状态
	getBtbMatchState:[
		{ value: 0, label: '未开始' },
		{ value: 1, label: '第一节' },
		{ value: 2, label: '第一节完' },
		{ value: 3, label: '第二节' },
		{ value: 4, label: '第二节完' },
		{ value: 5, label: '第三节' },
		{ value: 6, label: '第三节完' },
		{ value: 7, label: '第四节' },
		{ value: 8, label: '第四节完' },
		{ value: 9, label: '完场' },
		{ value: 10, label: '加时' },
		{ value: 11, label: '加时（完）' },
		{ value: 12, label: '中断' },
		{ value: 13, label: '取消' },
		{ value: 14, label: '延期' },
		{ value: 15, label: '腰斩' },
		{ value: 16, label: '待定' },
		{ value: 17, label: '比赛异常' },
		{ value: 18, label: '弃权' },
	],
	// 其他球类的比赛状态
	otherBallMatchState:[
		{ value: 0, label:'未开始'},
		{ value: 1, label:'进行中'},
		{ value: 2, label:'完赛'},
		{ value: 3, label:'赛点'},
		{ value: 4, label:'中断'},
		{ value: 5, label:'取消'},
		{ value: 6, label:'延期'},
		{ value: 7, label:'腰斩'},
		{ value: 8, label:'待定'},
		{ value: 9, label:'弃权'},
	],
	//比赛事件
	footballMatchEvent: [
		{ value: 0, label: "进球" },
		{ value: 1, label: "点球" },
		{ value: 2, label: "乌龙球" },
		{ value: 3, label: "黄牌" },
		{ value: 4, label: "红牌" },
		{ value: 5, label: "两黄变一红" },
		{ value: 8, label: "点球射失" },
		{ value: 9, label: "界外球" },
		{ value: 10, label: "角球" },
		{ value: 11, label: "任意球" },
		{ value: 12, label: "球门球" },
		{ value: 13, label: "换人" },
		{ value: 18, label: "射正" },
		{ value: 19, label: "射偏" },
		{ value: 20, label: "进攻" },
		{ value: 21, label: "危险进攻" },
		{ value: 22, label: "控球率" },
		{ value: 23, label: "受伤" },
		{ value: 24, label: "加时结束" },
		{ value: 25, label: "点球大战结束" },
		{ value: 26, label: "伤停" },
		{ value: 27, label: "射中门框" },
		{ value: 28, label: "传球" },
		{ value: 29, label: "直塞" },
		{ value: 30, label: "越位" },
		{ value: 31, label: "抢断" },
		{ value: 32, label: "犯规" },
		{ value: 37, label: "扑救" },
		{ value: 40, label: "头球进球" },
		{ value: 103, label: "助攻" },
		{ value: 106, label: "控球" },
		{ value: 110, label: "普通犯规" },
		{ value: 111, label: "封堵" },
		{ value: 112, label: "拦截" },
		{ value: 113, label: "解围" },
		{ value: 114, label: "尝试过人" },
		{ value: 115, label: "过人成功" },
		{ value: 116, label: "传球丢球" },
		{ value: 117, label: "传中" },
	],
	liveAdvertisingTypes: [
		{value:1,label:'图片'},
		{value:2,label:'跑马灯'},
		{value:3,label:'加载'},
		{value:4,label:'暂停'},
		{value:5,label:'海报'},
		{value:6,label:'比分条'},
		{value:7,label:'节目名称'},
		{value:8,label:'台标'},
		{value:9,label:'播放结束广告'},
		{value:10,label:'轮播图'},
		{value:11,label:'比分大屏'},
		{value:12,label:'过场动画'},
		{value:13,label:'播放器Banner'},
		{value:14,label:'左下角弹出'},
		{value:15,label:'右下角弹出'},
		{value:16,label:'进入时全屏'},
		{value:17,label:'信息流广告'},
		{value:18,label:'比赛详情背景图'},
		{value:19,label:'启动图广告位'},
		{value:20,label:'首页居中弹窗'},
		{value:21,label:'充值页Banner'},
		// {value:22,label:'系统重要通知'},
		{value:23,label:'首页轮播图第一条'},
		{value:24,label:'比赛详情banner条广告'},
		{value:25,label:'赛事入驻页广告'},
		{value:26,label:'聊天室对话中的进入广告'},
		{value:27,label:'聊天室对话中的间歇性广告'},
		{value:28,label:'播放器画面上方固定文本'},
	],
	webOrigin:(()=>{
		let result = location.host;
		return result;
	})(),
	apiOrigin:(()=>{
		let result = process.env.VUE_APP_BASE_API;
		// 测试地址
		if(!result) result = 'https://www.mydomain.co/api/'; 
		var arr = result.split('//');
		if (arr[1]) {
			result = arr[1];
		}
		result = result.replace(/(\/api\/)$/,'');
		// console.log('apiOrigin:',result);
		return result;
	})(),
	apiOrigin2:'www.mydomain.co/',
	resourceOrigin:'//res.mydomain.co'
}